import { useState, useEffect, useMemo } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  Container,
  // Divider,
  Grid,
  Typography,
  Stack,
  Button,
  Box,
  // CircularProgress,
} from "@common-ui/ui";
import AddIcon from "@mui/icons-material/Add";

import DisplayPlaceForm from "./DisplayPlaceForm";
import { CreatePlaceDialog } from "../CreatePlaceDialog";

import {
  getCustomerPlaces,
  addNewCustomerPlace,
} from "../../../services/customer";
import { PlacesTreeView } from "../../Places/CustomerPlacesTreeView";
// import { customerPlaces } from "../../../__mocks__";

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}
export const Places = ({ addresses, doesUserHavePermission }) => {
  const [placesData, setPlacesData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [parent, setParent] = useState("");
  let params = useParams();
  let query = useQuery();

  let selectedOrg = String(query.get("place"))
    ? String(query.get("place"))
    : "";
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  async function init() {
    try {
      let orgPlaces = await getCustomerPlaces(params?.orgId, params?.id);
      setPlacesData(orgPlaces);
    } catch (error) {
      alert(error);
    }
  }

  const handleAddNewPlace = (attributes) => {
    console.log(attributes);
    const addNewPlace = async () => {
      try {
        const response = await addNewCustomerPlace(
          params?.orgId,
          params?.id,
          attributes
        );
        if (response === 200 || response === 204) {
          setRefresh(true);
        }
      } catch (error) {
        alert(error);
      }
    };
    addNewPlace();
  };

  const handleAddSubPlace = (parent) => {
    setParent(parent);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setParent("");
    setRefresh(true);
    setOpenDialog(false);
  };
  return (
    <>
      <Container maxWidth="md" component="main">
        <Stack direction="row" sx={{ maxWidth: { md: 800 } }}>
          <Grid item md={6} xs={12}>
            <Typography sx={{ my: 2 }} color="textPrimary" variant="h3">
              Client Places
            </Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            {doesUserHavePermission ? (
              <Button
                type="primary"
                variant="contained"
                sx={{ my: 3 }}
                onClick={() => setOpenDialog(true)}
              >
                <AddIcon />
                Add Place
              </Button>
            ) : (
              ""
            )}
          </Grid>
        </Stack>
        <Grid container spacing={2}>
          <Grid item md={3.5}>
            <Box sx={{ position: "sticky", top: "calc(55px)" }}>
              <PlacesTreeView
                data={placesData}
                handleAddSubPlace={handleAddSubPlace}
              />
            </Box>
          </Grid>
          {selectedOrg !== "null" ? (
            <Grid item md={8.5} sx={{ minHeight: 800 }}>
              {" "}
              <Box sx={{ position: "sticky" }}>
                <DisplayPlaceForm
                  doesUserHavePermission={doesUserHavePermission}
                  init={init}
                  orgId={params?.orgId}
                  customerId={params?.id}
                  handleAddSubPlace={handleAddSubPlace}
                  selectedPlaceId={selectedOrg}
                  // setSelectedPlaceId={setSelectedPlaceId}
                  addresses={addresses}
                  setRefresh={setRefresh}
                />
              </Box>
            </Grid>
          ) : (
            <Grid item md={8.5}></Grid>
          )}
        </Grid>
      </Container>
      <CreatePlaceDialog
        handleClose={handleCloseDialog}
        open={openDialog}
        orgId={params?.orgId}
        customerId={params?.id}
        handleAddSubPlace={handleAddNewPlace}
        selectedPlaceId={selectedOrg}
        init={init}
        // setSelectedPlaceId={setSelectedPlaceId}
        addresses={addresses}
        setRefresh={setRefresh}
        parent={parent}
      />
    </>
  );
};
